<template>
    <RegularModal ref="modal">
        <template v-slot:title>
            <h4 class="modal-title">{{ translate("admin_create_bracket.teams_in_bracket") }}</h4>
        </template>
        <template v-slot:body>
            <table class="table is-hoverable is-fullwidth">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>{{ translate("common.academy") }}</th>
                        <th>{{ translate("common.total_competitors") }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(academy, index) in countedAcademies" :key="academy.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ academy.name }}</td>
                        <td>{{ academy.totalCompetitors }}</td>
                    </tr>
                </tbody>
            </table>
        </template>
        <template v-slot:footer>
            <button @click="close" class="button">
                {{ translate("common.close") }}
            </button>
        </template>
    </RegularModal>
</template>

<script>
    import translatorMixin from "../Common/translatorMixin";
    import RegularModal from "../Common/RegularModal.vue";

    export default {
        name: "academies-summary",
        components: {
            RegularModal,
        },
        mixins: [translatorMixin],
        props: ["competitors"],
        computed: {
            countedAcademies() {
                const academies = {};
                this.competitors.forEach(competitor => {
                    if (!academies[competitor.academy]) {
                        academies[competitor.academy] = 0;
                    }
                    academies[competitor.academy]++;
                });

                return Object.keys(academies)
                    .map(academyName => {
                        return {
                            name: academyName,
                            totalCompetitors: academies[academyName],
                        };
                    })
                    .sort((a, b) => {
                        return b.totalCompetitors - a.totalCompetitors;
                    });
            },
        },
        methods: {
            open() {
                this.$refs.modal.open();
            },
            close() {
                this.$refs.modal.close();
            },
        },
    };
</script>
